import templateUrl from './review-modal.component.html'

export const ReviewModalComponent = {
    templateUrl,
    controller: ReviewModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}




function ReviewModalController($scope, $state, $q, utilityService, onboardingDocumentService) {
    'ngInject';
    const vm = this;
    vm.allComments = [];
    vm.applicationId;
    //vm.submit = submit;
    vm.cancel = cancel;
    vm.requestChanges = requestChanges;
    vm.$onInit = function () {
        console.log(vm.resolve);
        vm.allComments = vm.resolve.allComments;
        vm.notification = vm.resolve?.notification ?? vm.notification;
        vm.applicationId = vm.resolve.application.ApplicationId;
    }

    //function submit() {
    //    if (vm.resolve.state) {
    //        vm.dismiss();
    //        return vm.resolve.params != null ? $state.go(vm.resolve.state, vm.resolve.params) : $state.go(vm.resolve.state);
    //    }

    //}
    function cancel() {
        vm.isComment = false;
        vm.isChangeRequested = false;
        vm.isEmployerView = false;
        vm.commentText = '';
        vm.close();
    }

    function requestChanges() {
        utilityService.showLoading();
        var empId = vm.resolve.application.EmployeeId;
        let statusPromises = [];
        //statusPromises.push($q.defer());
        if (vm.crForm.fw4) {
            statusPromises.push(onboardingDocumentService.setReviewRequired(empId, '5'));
        }
        if (vm.crForm.pw4 && vm.selectedApplication != null && vm.selectedApplication.ProvinceW4 !== 'NotRequired') {
            statusPromises.push(onboardingDocumentService.setReviewRequired(empId, '2'));
        }
        if (vm.crForm.i9) {
            statusPromises.push(onboardingDocumentService.setReviewRequired(empId, '3'));
        }
        if (vm.crForm.profile) {
            statusPromises.push(onboardingDocumentService.setReviewRequired(empId, '6'));
        }
        if (vm.crForm.dd) {
            statusPromises.push(onboardingDocumentService.setReviewRequired(empId, '7'));
        }

        return $q.all(statusPromises).then((results) => {
            var allTrue = results.every(function (result) {
                return result === true;
            });
            if (!allTrue) {
                return $q.reject('Error updating status');
            }
        }).then(() => {
            return onboardingDocumentService.saveComment({
                ApplicationId: vm.applicationId,
                UserName: vm.resolve.employee.UserName,
                Text: vm.crForm.reviewcommentText
            });
        }).then(function (isSaved) {
            if (isSaved === true) {
                onboardingDocumentService.retrieveComments(vm.applicationId)
                    .then(function (comments) {
                        vm.crForm.reviewcommentText = '';
                        vm.allComments = comments;
                        utilityService.hideLoading();
                    });
                /* $state.reload();*/
            } else {
                utilityService.hideLoading();
                alert("Saving Comment failed");
            }
            return isSaved;
        }).then(() => {
            vm.close();
        }).catch((err) => {
            utilityService.hideLoading();
            alert("Saving failed: " + utilityService.getExceptionMessage(err));
        });
    }
}


export const ReviewModal = {
    component: "apexReviewModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'xs',
    backdrop: 'static'
}
